module.exports = __webpack_public_path__ + "static/lauren-santi-ffcf35fc23e6d08c36f89a6976ccdb65.jpg";